<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <button mat-raised-button routerLink="/items" id="back" class="m-1 mr-2">
    <mat-icon>arrow_back</mat-icon> Back
  </button>

  <button
    mat-raised-button
    routerLink="/items/{{ item.id }}/view"
    id="view"
    *ngIf="item?.id"
    class="m-1 mr-2">
    <mat-icon>visibility</mat-icon> View
  </button>

  <button
    mat-raised-button
    (click)="delete()"
    *ngIf="item?.id"
    color="warn"
    matTooltip="Delete Item"
    id="delete"
    class="m-1 mr-2">
    <mat-icon>delete</mat-icon> Delete
  </button>
</nav>

<div class="container-fluid p-3">

  <div class="row">
    <div class="col-12 col-lg-6">

      <div class="card">
        <div class="card-body">
          <h5 class="card-title mb-4">Item</h5>

          <form #form="ngForm" (ngSubmit)="onSubmit()">

            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Name</mat-label>
              <input matInput placeholder="Name" [(ngModel)]="item.name" name="name" type="text" required #name id="name" />
              <mat-error *ngIf="!name.valid">Please enter an Item name.</mat-error>
            </mat-form-field>

            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Question</mat-label>
              <input required matInput placeholder="Question" [(ngModel)]="item.question" name="question" type="text" id="question" />
            </mat-form-field>

            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Tooltip</mat-label>
              <textarea required placeholder="Tooltip" matInput name="tooltip" id="tooltip" rows="5" [(ngModel)]="item.tooltip"></textarea>
            </mat-form-field>

            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Sort Order</mat-label>
              <input required matInput placeholder="Sort Order" [(ngModel)]="item.sort_order" name="sort_order" type="number" id="sort_order" />
              <mat-hint>The pre-qualification items are ordered by default using the sort order number in ascending order.</mat-hint>
            </mat-form-field>

            <div class="full-width">
              <button
                mat-raised-button
                color="primary"
                id="save"
                [disabled]="!form.valid || inProgress"
                type="submit"
                class="my-2 ml-1 mr-2">
                <mat-icon>save</mat-icon> Save
              </button>
            </div>

          </form>

        </div>
      </div>

    </div>
  </div>

</div>
